import React from 'react';
import './section2.css'
import Text from '../common/text';
import Title from '../common/title';

const Sec2 = () => {
    return ( <>
    <section className='sec2'>
        <Title title='Start Exploring' t='title1' />
            <Text text='Whether you re seeking a serene escape or a modern family home, ' x='text'  />

        <article className='sec2-row'>
            <div className='sec2-div'>
                <div className='box1'>Villas</div>
                <div className='box2'>Apartment</div>
            </div>
                <div className='box3'>Other Project</div>

        </article>
    </section>
    </> );
}
 
export default Sec2;